module.exports = __webpack_public_path__ + "img/pricing-gold.2657f281.png";